const API_BASE = "https://tansmartx-api-446662168422.asia-southeast1.run.app";

export async function fetchAiSummary(projectId, granularity = "daily") {
  const res = await fetch(
    `${API_BASE}/api/gcp/ai-summary?projectId=${encodeURIComponent(projectId)}&granularity=${encodeURIComponent(granularity)}`
  );

  if (!res.ok) {
    throw new Error(`Failed to load AI summary: ${res.status}`);
  }

  return res.json();
}